import {connect} from "react-redux";
import { Box } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {TimeLine} from "./TimeLine";
import {Network} from "../../fstn/network";
import {Cursor} from "../../fstn/cursor";
import {selectProjects} from "../../redux/selectors/firebase";
import {ProjectDetails} from "../../redux/types/firebase";
import {ActionFactory} from "../../fstn/actionFactory";

const useStyles = makeStyles(theme => ({
    content: {
    },
    video: {
        margin: theme.spacing(4),
        flexGrow: 4
    }
}));
interface Props {
    cursor: Cursor
    factory: ActionFactory
    network: Network
    project: string
    projects: {[key: string]: ProjectDetails}
}
function Video({cursor, factory, network, project, projects}: Props) {
    const classes = useStyles();

    return (
        <Box className={classes.content} display="flex" flexDirection="column">
            <TimeLine factory={factory} network={network}/>
        </Box>
    );
}

const mapStateToProps = (store: never) => ({
    projects: selectProjects(store)
});

export default connect(mapStateToProps, {
})(Video);
